import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { HTTPService, HelperService, DataService } from 'app/services';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmDismissDialogComponent } from 'app/modules/shared/components/confirm-dismiss-dialog/confirm-dismiss-dialog.component';

import { findIndex } from 'lodash';

@Component({
  selector: 'app-color-dropdown',
  templateUrl: './app-color-dropdown.component.html',
  styleUrls: ['./app-color-dropdown.component.scss'],
})
export class AppColorDropdownComponent implements OnInit {
  @Input() value: any;
  @Input() options: any[];

  @Output() select = new EventEmitter<any>();
  @Output() saveUpdateColor = new EventEmitter<any>();

  isColorEdited: boolean = false;
  isColorNew: boolean = false;
  isAddMode: boolean = false;
  editableColor: any = {};
  isHideColorValue: boolean = false;
  isShowTrashIcon: boolean = false;
  validate: any = {};
  defaultColorValue: any[] = ['#00c19f', '#d47877', '#dda157', '#4e94c8', '#919796', '#00C19F', '#D47877', '#DDA157', '#4E94C8', '#919796'];
  oldColor = '';
  constructor(private httpService: HTTPService, private helperService: HelperService, private dialogService: DialogService, private dataService: DataService) {}

  ngOnInit() {}

  selectColor(value) {
    this.select.emit(value);
    this.editableColor = {};
    this.isAddMode = false;
  }

  showEditOption(event: Event, color: any) {
    event.stopPropagation();
    this.validate = {};
    for (let i = 0; i <= this.defaultColorValue.length; i++) {
      this.isHideColorValue = this.defaultColorValue[i] === color.value ? true : false;
      if (this.isHideColorValue) {
        break;
      }
    }
    this.isColorEdited = true;
    this.isColorNew = false;
    this.isAddMode = true;
    this.editableColor = { ...color };
  }

  showTrashIcon(event: Event, color: any) {
    for (let i = 0; i <= this.defaultColorValue.length; i++) {
      this.isShowTrashIcon = this.defaultColorValue[i] === color.value ? true : false;
      if (this.isShowTrashIcon) {
        break;
      }
    }
  }

  handleChangeLabel(label: string) {
    this.editableColor.label = label;
  }

  handleChangeValue(value: string) {
    this.editableColor.value = value;
  }

  handleCancel(event: Event) {
    event.stopPropagation();

    this.isColorEdited = false;
    this.isAddMode = false;
    this.editableColor = {};
  }

  handleAddColor(event: Event) {
    event.stopPropagation();
    this.validate = {};
    this.isColorEdited = false;
    this.isAddMode = true;
    if (this.options && this.options.length >= 15) {
      this.isAddMode = false;
      this.helperService.showToaster('error', 'The maximum number of colors is 15');
    } else {
      this.isColorNew = true;
    }
  }

  deleteColor(id) {
    if (this.options.length) {
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i]._id === id) {
          this.options.splice(i, 1);
          break;
        }
      }
      this.httpService.updateAppointmentColorLabel(this.options).then(
        (res) => {
          this.helperService.showToaster('success', 'Successfully deleted');
        },
        (err) => {
          // this.toastr.error(err);
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  handleSave(event: Event) {
    if (!this.validateColorLabel()) {
      event.stopPropagation();
      return;
    }
    if (!this.validateColorValue()) {
      event.stopPropagation();
      return;
    }
    if (!this.editableColor.value) {
      this.validate.colorValue = '* Color required';
      return;
    }
    if (!this.editableColor.label) {
      this.validate.colorName = '* Color name required';
      return;
    }
    event.stopPropagation();
    if (this.isColorEdited) {
      const ref = this.dialogService.open(ConfirmDismissDialogComponent, {
        width: '35%',
        styleClass: 'small-heading-dialog',
        showHeader: false,
        data: {
          title: 'Update color?',
          message: 'The new color will be applied to all past and upcoming appointments that contain this color.',
          button: {
            success: { title: 'Confirm' },
            cancel: { title: 'Cancel' },
          },
        },
      });

      const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
        if (isSuccess) {
          const index = findIndex(this.options, { _id: this.editableColor._id });

          if (index !== -1) {
            this.oldColor = this.helperService.deepCopy(this.options[index].value);
            if (this.options[index].value === this.value) {
              this.value = this.editableColor.value;
              this.select.emit(this.editableColor.value);
            }
            this.options[index].label = this.editableColor.label;
            this.options[index].value = this.editableColor.value;
            this.isColorEdited = false;
          }
          this.httpService.updateAppointmentColorLabel(this.editableColor, this.oldColor).then(
            (res) => {
              this.isAddMode = false;
              this.dataService.sendData(this.dataService.typePassData('update-appt-column', { data: {} }));
              this.editableColor = {};
              this.helperService.showToaster('success', 'Successfully updated');
            },
            (err) => {
              this.helperService.showToaster('error', err);
            }
          );
        } else {
          this.isAddMode = false;
          this.editableColor = {};
        }
        onClose.unsubscribe();
      });
    } else if (this.isColorNew && this.options.length < 15) {
      this.options.push(this.editableColor);
      this.editableColor = {};
      this.isAddMode = false;
      this.httpService.updateAppointmentColorLabel(this.options).then(
        (res) => {
          this.helperService.showToaster('success', 'Successfully added');
          this.saveUpdateColor.emit(res);
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
    }
  }

  validateColorLabel() {
    let isValidLabel: boolean = true;

    this.options.map((o) => {
      if (o._id === this.editableColor._id && o.label === this.editableColor.label) {
        isValidLabel = true;
      } else if (o.label === this.editableColor.label) {
        isValidLabel = false;
        this.validate.colorName = 'Color Name already exists';
      }
    });
    return isValidLabel;
  }

  validateColorValue() {
    let isValidValue: boolean = true;

    this.options.map((o) => {
      if (o._id === this.editableColor._id && o.value === this.editableColor.value) {
        isValidValue = true;
      } else if (o.value === this.editableColor.value) {
        isValidValue = false;
        this.validate.colorValue = 'Color already exist';
        // this.helperService.showToaster('error', 'Color already exist');
      }
    });
    return isValidValue;
  }
}
